/*
Restraint manifesto:
House of Namya should never bounce, wobble, flash, chase the cursor, or slide aggressively across the viewport. The brand depends on quiet confidence: one fade, one soft lift, one measured transition at a time. Avoid loud gradients, parallax tricks, spinning badges, confetti, and motion that calls attention to itself rather than the coffee. Movement should feel like breath, not advertising.
*/
document.addEventListener('DOMContentLoaded', function () {
  const debounce = (fn, wait = 120) => {
    let timer;
    return (...args) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => fn(...args), wait);
    };
  };

  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', () => {
      if (nav) nav.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });

  const header = document.querySelector('.site-header');
  const setHeaderState = debounce(() => {
    if (header) header.classList.toggle('scrolled', window.scrollY > 80);
  }, 20);
  setHeaderState();
  window.addEventListener('scroll', setHeaderState, { passive: true });

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealEls = document.querySelectorAll('[data-reveal], .reveal');
  if (revealEls.length) {
    if (reduced || !('IntersectionObserver' in window)) {
      revealEls.forEach((el) => el.classList.add('is-visible'));
    } else {
      const io = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
      revealEls.forEach((el) => io.observe(el));
    }
  }

  const bar = document.querySelector('[data-announcement-bar]');
  if (bar && sessionStorage.getItem('honAnnouncementClosed') !== 'true') {
    bar.hidden = false;
    const messages = Array.from(bar.querySelectorAll('[data-announcement-track] p'));
    let index = 0;
    let paused = false;
    const show = (next) => {
      messages.forEach((msg, i) => msg.classList.toggle('is-active', i === next));
    };
    const timer = window.setInterval(() => {
      if (paused || !messages.length) return;
      index = (index + 1) % messages.length;
      show(index);
    }, 5000);
    bar.addEventListener('mouseenter', () => { paused = true; });
    bar.addEventListener('mouseleave', () => { paused = false; });
    const close = bar.querySelector('[data-announcement-close]');
    if (close) close.addEventListener('click', () => {
      sessionStorage.setItem('honAnnouncementClosed', 'true');
      bar.hidden = true;
      window.clearInterval(timer);
    });
  } else if (bar) {
    bar.hidden = true;
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const productJson = section.querySelector('[data-product-json]');
    if (!productJson) return;
    const product = JSON.parse(productJson.textContent);
    const form = section.querySelector('[data-product-form]');
    const idInput = section.querySelector('[data-variant-id]');
    const priceEl = section.querySelector('[data-product-price]');
    const atc = section.querySelector('[data-main-atc]');
    const sticky = document.querySelector('[data-sticky-atc]');
    const stickyButton = document.querySelector('[data-sticky-atc-button]');
    const stickyVariant = document.querySelector('[data-sticky-variant]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const qty = section.querySelector('.product-qty .qty-input');
    const mainImage = section.querySelector('[data-main-product-image]');

    const setVariant = (variantId) => {
      const variant = product.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      section.querySelectorAll('[data-variant-button]').forEach((button) => {
        button.classList.toggle('is-selected', String(button.dataset.variantId) === String(variant.id));
      });
      const price = window.HONCart ? window.HONCart.formatMoney(variant.price) : (variant.price / 100).toFixed(2);
      if (priceEl) priceEl.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;
      if (stickyVariant) stickyVariant.textContent = variant.title;
      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      const selectedButton = section.querySelector(`[data-variant-button][data-variant-id="${variant.id}"]`);
      if (selectedButton && selectedButton.dataset.variantImage && mainImage) {
        mainImage.classList.add('is-fading');
        window.setTimeout(() => {
          mainImage.src = selectedButton.dataset.variantImage;
          mainImage.alt = `${product.title} ${variant.title}`;
          mainImage.classList.remove('is-fading');
        }, 120);
        section.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.dataset.sizeKey === selectedButton.dataset.sizeKey);
        });
      }
      const detail = section.querySelector('[data-size-detail] span');
      if (detail) {
        const title = String(variant.title || '').toLowerCase();
        let text = 'Washed process · Bourbon & Caturra · 1,100–1,690m elevation · creamy body, plum, dark chocolate and sweet jaggery finish.';
        if (title.includes('250')) text = '250g tasting pack · perfect for first orders, gifting and fresh weekly brewing.';
        if (title.includes('500')) text = '500g everyday pack · balanced freshness and value for regular home brewing.';
        if (title.includes('1kg') || title.includes('1 kg') || title.includes('1000')) text = '1kg best-value pack · ideal for family, office and daily coffee lovers.';
        detail.textContent = text;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    section.querySelectorAll('[data-variant-button]').forEach((button) => {
      button.addEventListener('click', () => setVariant(button.dataset.variantId));
    });

    section.querySelectorAll('[data-product-minus], [data-product-plus]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!qty) return;
        const current = Math.max(1, Number(qty.value || 1));
        qty.value = button.matches('[data-product-plus]') ? current + 1 : Math.max(1, current - 1);
      });
    });

    section.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!mainImage) return;
        section.querySelectorAll('[data-gallery-thumb]').forEach((b) => b.classList.remove('is-active'));
        button.classList.add('is-active');
        mainImage.classList.add('is-fading');
        const nextSrc = button.dataset.image;
        const nextAlt = button.dataset.alt || product.title;
        window.setTimeout(() => {
          mainImage.src = nextSrc;
          mainImage.alt = nextAlt;
          mainImage.classList.remove('is-fading');
        }, 160);
      });
    });

    if (sticky && atc && 'IntersectionObserver' in window && window.matchMedia('(max-width: 760px)').matches) {
      const io = new IntersectionObserver((entries) => {
        const visible = entries[0]?.isIntersecting;
        sticky.hidden = Boolean(visible);
      }, { threshold: 0.1 });
      io.observe(atc);
      if (stickyButton) stickyButton.addEventListener('click', () => atc.click());
    }

    const selectedFromUrl = new URLSearchParams(window.location.search).get('variant');
    if (selectedFromUrl) {
      const direct = product.variants.find((v) => String(v.id) === String(selectedFromUrl));
      const byTitle = product.variants.find((v) => String(v.title || '').toLowerCase().includes(String(selectedFromUrl).toLowerCase().replace('-', ' ')));
      setVariant((direct || byTitle || {}).id || selectedFromUrl);
    }
    else if (idInput && idInput.value) setVariant(idInput.value);
  });

  const updateCartLine = async (line, input, quantity) => {
    const key = line?.getAttribute('data-key');
    if (!key || !input) return;
    const oldValue = input.value;
    input.value = quantity;
    line.classList.add('cart-updating');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) throw new Error('Cart update failed');
      window.location.href = `${root}cart`;
    } catch (error) {
      input.value = oldValue;
      line.classList.remove('cart-updating');
      console.error(error);
    }
  };

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-cart-page-minus]');
    const plus = event.target.closest('[data-cart-page-plus]');
    if (!minus && !plus) return;
    const line = event.target.closest('.cart-line');
    const input = line?.querySelector('[data-cart-page-qty]');
    if (!input) return;
    const current = Math.max(0, Number(input.value || 0));
    const next = plus ? current + 1 : Math.max(0, current - 1);
    if (next === current) return;
    updateCartLine(line, input, next);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-cart-page-qty]')) return;
    const line = event.target.closest('.cart-line');
    const next = Math.max(0, Number(event.target.value || 0));
    updateCartLine(line, event.target, next);
  });

  window.HON = Object.assign(window.HON || {}, { debounce });
});
